angular
    .module("app")
    .controller("toBeCorrectedCtrl", function (
        $scope,
        $transactionFactory,
        $location,
        $instantService,
        $rootScope

    ) {
        var init = function () {

            $scope.enableButton = false;
            $scope.errorInfo = $transactionFactory.get();
        };

        init();

        $scope.goToHomePage = function () {
            $location.path("/");
        }
        $scope.privacy = {
            documentoPrivacyFirmato: {
                selected: false,
                nameFile: ""
            }
        };


        $scope.uploadOk = function (model) {
            $scope.enableButton = true;
            $scope.documentUploadAndNote = model;
        }

        $scope.uploadNotOk = function (model) {
            $scope.enableButton = false;
            $scope.documentUploadAndNote = model;
        }

        $scope.sendDocuments = function () {

            $instantService.sendDocumentCorrectToWf(
                    $scope.documentUploadAndNote, $scope.errorInfo.idWfInstance, $scope.errorInfo.typeWf)
                .then(function (response) {
                    if (response.success) {
                        console.log(response);
                        $location.path('/');
                    } else {
                        $rootScope.$broadcast("addAlert", {
                            text: "ERROR_NEXT"
                        })
                    }
                })
                .catch(function (error) {

                    console.log(error);
                    $rootScope.$broadcast("addAlert", {
                        text: "ERROR_NEXT"
                    })
                })


        }
    });